const INFLUENCER_CONTENT_TYPE_ENUM = {
    MEDIA: 'media',
    LINK: 'link',
};
const INFLUENCER_CONTENT_STAGE_ENUM = {
    PENDING: 'pending',
    CHANGES_REQUESTED: 'changesRequested',
    APPROVED: 'approved',
};
const INFLUENCER_CONTENT_COMMENT_AUTHOR_TYPE = {
    USER: 'user',
    INFLUENCER: 'influencer',
};
const INFLUENCER_CONTENT_REVIEW_TYPE = {
    APPROVAL: 'approval',
    CHANGE_REQUEST: 'changeRequest',
};
export { INFLUENCER_CONTENT_TYPE_ENUM, INFLUENCER_CONTENT_STAGE_ENUM, INFLUENCER_CONTENT_COMMENT_AUTHOR_TYPE, INFLUENCER_CONTENT_REVIEW_TYPE, };
